var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewShortlist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM17.1339 10.3839C17.622 9.89573 17.622 9.10427 17.1339 8.61612C16.6457 8.12796 15.8543 8.12796 15.3661 8.61612L11.25 12.7322L9.63388 11.1161C9.14573 10.628 8.35427 10.628 7.86612 11.1161C7.37796 11.6043 7.37796 12.3957 7.86612 12.8839L10.3661 15.3839C10.8543 15.872 11.6457 15.872 12.1339 15.3839L17.1339 10.3839Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewShortlist);
export default __webpack_public_path__ + "static/media/new-shortlist.35af9f60d98b9e4858e7210d56b0b82d.svg";
export { ForwardRef as ReactComponent };